import { useEffect, useRef, useState } from 'react';
import { useOnline } from './connection.ts';
import './connection.css';

/** A calm line while the server can't be reached, and a moment's "Back online" after (QA-058). */
export function ConnectionLine() {
  const online = useOnline();
  const [back, setBack] = useState(false);
  const was = useRef(online);
  useEffect(() => {
    if (online && !was.current) {
      setBack(true);
      const t = setTimeout(() => setBack(false), 2500);
      was.current = online;
      return () => clearTimeout(t);
    }
    was.current = online;
  }, [online]);
  if (online && !back) return null;
  return (
    <p className={`connection-line${online ? ' ok' : ''}`} role="status" aria-live="polite">
      {online
        ? 'Back online.'
        : 'No connection. Retrying… Nothing you change counts as saved until it says so.'}
    </p>
  );
}
